import { toast } from '@/libs/toaster'
export const errorToaster = (key: string, message: string) => {
	// toast.error(`Error in ${key}: ${message}`)
	toast.error(`${message}`)
}
